export default __webpack_public_path__ + "static/media/file-invoice.fb144f41.svg";